angular.module('unica_invitation_transfer_event.invitation_transfer_event_controllers')

.controller('InvitationTransferEventAssignController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm, $uibModal,
	InvitationListListService, UserListService, InvitationTransferListService,
	InvitationTransferEventCreateService
) {
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.invitationTransferData = {};
	$rootScope.resetInvitationTransferData = function()
	{
		$rootScope.invitationTransferData = {
			event_id:      				$stateParams.event_id,
			invitation_id: 				[],
			invitation_transfer_id:  	null
		};
	};
	$rootScope.resetInvitationTransferData();




	/**
	 * ===================================
	 *
	 *   SEARCH ADVANCED OF USERS
	 *
	 * ===================================
	 */

	$scope.loadInvitationLists = function()
	{
		$scope.showLoader();

		InvitationListListService
			.fullList( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.invitationsLists = data;
				}
			});
	};

	$scope.loadInvitationLists();

	$scope.userSearchData = {};
	$scope.clearUserSearch = function() {
		$scope.userSearchData = {
			event_id: $stateParams.event_id,
			status:  'confirmed',
			no_transfer:  false,
			show_acc:  true
		};

		$scope.userList = [];
	};
	$scope.clearUserSearch();

	$scope.userList = [];
	$scope.advancedUserSearch = function()
	{
		$scope.showLoader();

		UserListService
			.advancedSearch( $scope.userSearchData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.userList = data;
				}
			});
	};
	/**
	 * =================================== *
	 */


	$scope.openImportInvitationTransferEventAssignModal = function ()
	{
		var modalInstance = $uibModal.open({
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			controller: 'ModalImportInvitationTransferEventAssignInstanceController',
			controllerAs: '$ctrl',
			templateUrl: './templates/modals/import-invitation-transfer-event.html',
			size: 'lg',
			windowClass: 'modal-invitation-list'
		});

		modalInstance.result.then(function (data) {

			if ( data.result === 'ok' ) {
				$scope.showSuccessMsg('Assegnati: ' + data.created.length + ' - Saltati: ' + data.skipped.length );

				$state.go('app.hospitality.invitation_transfer_event_list', { event_id: $stateParams.event_id });
			}

		}, function () { });
	};


	/**
	 * ===================================
	 *
	 *   SEARCH TRANSFERS
	 *
	 * ===================================
	 */

	$scope.transferSearchData = {};

	$scope.clearTransferSearch = function() {
		$scope.transferSearchData = {
			event_id: $stateParams.event_id,
			no_invitation: true
		};
		$scope.transferInvitationList = [];
	};
	$scope.clearTransferSearch();

	$rootScope.getTransferList();

	$scope.transferInvitationList = [];
	$scope.advancedTransferSearch = function()
	{
		$scope.showLoader();

		InvitationTransferListService
			.search( $stateParams.event_id, $scope.transferSearchData )
			.then(function(data) {
				$scope.hideLoader();
				if ( data ) {
					$scope.transferInvitationList = data;
				}
			});
	};
	$scope.advancedTransferSearch();


	$scope.maxUsers = 0;
	$scope.changedInvitationTransfer = function(invTra)
	{
		$scope.maxUsers = invTra.free;
		$rootScope.invitationTransferData.invitation_id = [];
	}

	$scope.bDisableInvitationUsers = false;
	$scope.toggleInvitationUsers = function(tmpInvitationId){
		var idx = $rootScope.invitationTransferData.invitation_id.indexOf(tmpInvitationId);
    
		if (idx > -1) {
			$rootScope.invitationTransferData.invitation_id.splice(idx, 1);
		}
		else {
			$rootScope.invitationTransferData.invitation_id.push(tmpInvitationId);
		}

		$scope.bDisableInvitationUsers = ($rootScope.invitationTransferData.invitation_id.length >= $scope.maxUsers)
	}


	/**
	 * ===================================
	 *
	 *   ASSIGN TRANSFER 
	 *
	 * ===================================
	 */

	$scope.saveInvitationTransferEvent = function()
	{
		$scope.showLoader();

		if ($rootScope.invitationTransferData.invitation_id.length > 0 ) {

			for (var index = 0; index < $rootScope.invitationTransferData.invitation_id.length; index++) {

				var objInvitationTransferData = {
					event_id:      				$stateParams.event_id,
					invitation_id: 				$rootScope.invitationTransferData.invitation_id[index],
					invitation_transfer_id:  	$rootScope.invitationTransferData.invitation_transfer_id
				};

 				InvitationTransferEventCreateService
					.create( objInvitationTransferData )
					.then(function(data) {

						if ( data ) {
							$scope.showSuccessMsg('Assegnazione Transfer avvenuto con successo!', '');
						}
					
					});
			}

			setTimeout(function() {
				$state.go('app.hospitality.invitation_transfer_event_list', { event_id: $stateParams.event_id });
			}, 2000);
		}
		else
		{
			$scope.showErrorMsg('Nessun utente selezionato');
			$scope.hideLoader();
		}

		
	};


	
	/**
	 * ===================================
	 *
	 *   POST TRANSFER ASSIGN
	 *
	 * ===================================
	 */
	$scope.postAssign = function()
	{
		for ( var i = 0; i < $scope.userList.length; i++ ) {
			if ( $rootScope.invitationTransferData.invitation_id === $scope.userList[i].invitation_id ) {
				$scope.userList.splice(i, 1);
			}
		}

		for ( var i = 0; i < $scope.transferInvitationList.length; i++ ) {
			if ( $rootScope.invitationTransferData.invitation_transfer_id === $scope.transferInvitationList[i].id ) {
				$scope.transferInvitationList.splice(i, 1);
			}
		}
	};



	$scope.convertToDate = function (stringDate){
		var dateOut = new Date(stringDate);
		return dateOut;
	};

})
	.controller('ModalImportInvitationTransferEventAssignInstanceController',
		function (
			$scope, $stateParams, $rootScope,
			$uibModalInstance, FileUploader, getBaseApiURL, Session
		) {

			$scope.importInvitationAssignmentsData = {
				csv: ''
			};

			$scope.uploader = new FileUploader({
				removeAfterUpload: true,
				alias: 'csv',
				url: getBaseApiURL + '/import/assign-invitation-transfer-event/' + $stateParams.event_id,
				headers: {
					Authorization : 'Bearer ' + Session.token,
					Accept: 'application/json'
				}
			});

			$scope.uploader.onCompleteItem = function(fileItem, response) {
				$scope.hideLoader();
				if ( response.result === 'ko' && response.message ) {
					$rootScope.showErrorMsg( response.message );
				} else {
					$scope.showSuccessMsg('Operazione completata');
				}
				$uibModalInstance.close( response );
			};

			$scope.deleteImportInvitationAssignmentsCsv = function() {
				angular.element(document.querySelector('.assignments_csv')).val(null);
			};

			$scope.importInvitationAssignments = function () {
				$scope.showLoader();
				$scope.uploader.uploadAll();
			};

			$scope.closeModal = function() {
				$uibModalInstance.dismiss('cancel');
			};

		});